<template>
  <el-dialog title="登记付款" :visible="visible" width="min(640px, 94vw)" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="!saving" append-to-body @close="close">
    <div v-loading="loading">
      <el-alert v-if="error" :title="error" type="error" :closable="false" show-icon />
      <template v-if="claim">
        <div class="payment-claim"><strong>{{ claim.beneficiaryName }} · {{ claim.reason }}</strong><div>{{ claim.payerCompanyName }}</div><div>待付款 <b>¥ {{ money(pending(claim)) }}</b></div></div>
        <el-alert title="请在实际转账完成后登记。" type="info" :closable="false" />
        <el-form label-position="top" :disabled="saving || retry">
          <el-form-item label="付款金额（元）" required><el-input v-model="payment.amount" inputmode="decimal" /></el-form-item>
          <el-form-item label="实际付款时间" required><el-date-picker :key="paymentDefaultTime" v-model="payment.paymentTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" :default-time="paymentDefaultTime" style="width:100%" /></el-form-item>
          <el-form-item label="银行流水 / 支付参考号（选填）"><el-input v-model="payment.paymentReference" maxlength="100" /></el-form-item>
          <el-form-item label="付款凭证（选填）"><file-upload v-model="paymentFiles" upload-path="/crmExpenseClaim/upload" :limit="12" :multiple="true" :read-only="saving || retry" /></el-form-item>
          <el-form-item label="备注（选填）"><el-input v-model="payment.remark" maxlength="500" /></el-form-item>
        </el-form>
      </template>
    </div>
    <div slot="footer"><el-button :disabled="saving || retry" @click="close">取消</el-button><el-button v-if="claim" type="primary" :loading="saving" :disabled="loading" @click="pay">{{ retry ? '重试确认' : '确认登记' }}</el-button></div>
  </el-dialog>
</template>
<script>
import { expenseDetail, payExpense } from '@/api/crm/expense'
import { money, pending, toCents } from '@/utils/expense'
import { now } from '@/utils/oaBusiness'
import FileUpload from '@/views/crm/components/fileUpload'
export default {
  name: 'ExpensePaymentDialog',
  components: { FileUpload },
  data: () => ({ visible: false, loading: false, saving: false, retry: false, error: '', claim: null, payment: {}, paymentDefaultTime: '', paymentFiles: [], request: null }),
  methods: {
    money, pending,
    async open(id) {
      if (this.saving || this.retry) return
      this.visible = true; this.loading = true; this.error = ''; this.claim = null; this.request = null
      this.paymentFiles = []
      try {
        const d = (await expenseDetail(id)).data
        if (!d.canPay) throw new Error('该单据已结清或当前账号无权登记，请刷新列表')
        this.claim = d.claim
        const time = now()
        this.paymentDefaultTime = time.slice(11)
        this.payment = { claimId: id, amount: pending(d.claim), paymentTime: time, paymentReference: '', remark: '', requestKey: Date.now() + '-' + Math.random().toString(36).slice(2) }
      } catch (e) { this.error = e.message || '单据加载失败，请重试' }
      finally { this.loading = false }
    },
    close() {
      if (this.saving || this.retry) { this.visible = true; return }
      this.visible = false
      this.$emit('refresh')
    },
    async pay() {
      if (this.saving || this.loading) return
      try {
        if (!this.request) {
          const cents = toCents(this.payment.amount)
          if (!cents || cents > toCents(pending(this.claim))) throw new Error('付款金额须大于0且不超过待付余额')
          if (!this.payment.paymentTime) throw new Error('请填写实际付款时间')
          this.request = { ...this.payment, paymentTime: this.payment.paymentTime, paymentReference: (this.payment.paymentReference || '').trim(), fileObjs: JSON.stringify(this.paymentFiles) }
        }
        this.saving = true; this.error = ''
        await payExpense(this.request)
        this.request = null; this.retry = false; this.visible = false
        this.$message.success('付款已登记')
        this.$emit('paid')
      } catch (e) {
        // Uncertain transport results retain the exact body/key, including on retry.
        const message = e.message || '付款登记失败'
        this.retry = !!this.request && !e.businessRejected
        if (!this.retry) this.request = null
        this.error = this.retry ? '登记结果尚未确认，请重试确认，系统会避免重复登记。' : message
      } finally { this.saving = false }
    },
  },
}
</script>
<style scoped>
.payment-claim{line-height:1.7;padding-bottom:16px;overflow-wrap:anywhere}.payment-claim div{color:#606266;margin-top:6px}.payment-claim b{color:#2f80ed;font-size:20px}.el-form{margin-top:16px}
</style>
